"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHMenuNavigatorV32D = exports.KHMenuNavigatorV31D = exports.NavigationDirection = void 0;
var NavigationDirection;
(function (NavigationDirection) {
    NavigationDirection[NavigationDirection["Horizontal"] = 0] = "Horizontal";
    NavigationDirection[NavigationDirection["Vertical"] = 1] = "Vertical";
})(NavigationDirection || (exports.NavigationDirection = NavigationDirection = {}));
class KHMenuNavigatorV31D {
    constructor(dir) {
        this.dir = dir;
    }
    onLeft(menuSpec) {
        if (this.dir !== NavigationDirection.Horizontal)
            return;
        menuSpec.setPreviousIndex();
    }
    onRight(menuSpec) {
        if (this.dir !== NavigationDirection.Horizontal)
            return;
        menuSpec.setNextIndex();
    }
    onUp(menuSpec) {
        if (this.dir !== NavigationDirection.Vertical)
            return;
        menuSpec.setPreviousIndex();
    }
    onDown(menuSpec) {
        if (this.dir !== NavigationDirection.Vertical)
            return;
        menuSpec.setNextIndex();
    }
}
exports.KHMenuNavigatorV31D = KHMenuNavigatorV31D;
class KHMenuNavigatorV32D {
    constructor(wrapAround) {
        this.wrapAround = wrapAround;
    }
    onLeft(menuSpec) {
        const adjacent = this.computeInDirection(new Phaser.Math.Vector2(-1, 0), menuSpec.getSelectedOption(), menuSpec.getOptionsRaw());
        if (adjacent)
            menuSpec.setSelected(adjacent);
    }
    onRight(menuSpec) {
        const adjacent = this.computeInDirection(new Phaser.Math.Vector2(1, 0), menuSpec.getSelectedOption(), menuSpec.getOptionsRaw());
        if (adjacent)
            menuSpec.setSelected(adjacent);
    }
    onUp(menuSpec) {
        const adjacent = this.computeInDirection(new Phaser.Math.Vector2(0, -1), menuSpec.getSelectedOption(), menuSpec.getOptionsRaw());
        if (adjacent)
            menuSpec.setSelected(adjacent);
    }
    onDown(menuSpec) {
        const adjacent = this.computeInDirection(new Phaser.Math.Vector2(0, 1), menuSpec.getSelectedOption(), menuSpec.getOptionsRaw());
        if (adjacent)
            menuSpec.setSelected(adjacent);
    }
    computeInDirection(dir, go, selectables) {
        let thisBounds = go.bounds;
        let edge = new Phaser.Math.Vector2(thisBounds.centerX + thisBounds.width / 2 * dir.x, thisBounds.centerY + thisBounds.height / 2 * dir.y);
        let leftMost = 0;
        let rightMost = 0;
        let topMost = 0;
        let bottomMost = 0;
        let bestSelect = this.checkClosest(dir, edge, go, selectables);
        // If no match, find the farthest out and adjust the edge to be beyond that to look for wrap-around.
        if (!bestSelect && this.wrapAround) {
            for (const select of selectables) {
                if (go === select)
                    continue;
                if (!go.getIsSelectable())
                    continue;
                const bounds = select.bounds;
                const center = new Phaser.Math.Vector2(bounds.centerX, bounds.centerY);
                leftMost = Math.min(leftMost, center.x);
                rightMost = Math.max(rightMost, center.x);
                topMost = Math.min(topMost, center.y);
                bottomMost = Math.max(bottomMost, center.y);
            }
            if (dir.x < 0)
                edge.x = rightMost + 10;
            else if (dir.x > 0)
                edge.x = leftMost - 10;
            else if (dir.y < 0)
                edge.y = bottomMost + 10;
            else
                edge.y = topMost - 10;
            bestSelect = this.checkClosest(dir, edge, go, selectables);
        }
        return bestSelect;
    }
    checkClosest(dir, edge, go, selectables) {
        let bestMatch = -Infinity;
        let bestSelect = undefined;
        for (const select of selectables) {
            if (go === select)
                continue;
            if (!go.getIsSelectable())
                continue;
            const bounds = select.bounds;
            const center = new Phaser.Math.Vector2(bounds.centerX, bounds.centerY);
            const dirVector = center.subtract(edge);
            const dot = dir.dot(dirVector);
            // Only allow vectors at least slightly in the same direction.
            if (dot <= 0)
                continue;
            // This gets the percentage of alignment between the dir vector and the comparison
            // vector and divides it by the magnitude. This balances distance and alignment.
            const score = dot / dirVector.lengthSq();
            if (score > bestMatch) {
                bestMatch = score;
                bestSelect = select;
            }
        }
        return bestSelect;
    }
}
exports.KHMenuNavigatorV32D = KHMenuNavigatorV32D;
